import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';

const PreFooterCta = () => {
  return (
    <section className="py-24 px-6 relative overflow-hidden">
      {/* Massive Ambient Glow Behind the Card */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-electric-green/10 rounded-full blur-[150px] pointer-events-none" />

      <motion.div 
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-5xl mx-auto relative z-10"
      >
        <div className="relative bg-[#1A1F29]/60 backdrop-blur-2xl border border-white/10 rounded-3xl p-10 md:p-20 text-center overflow-hidden group shadow-2xl">
          
          {/* Subtle Top Border Glow on Hover */}
          <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-electric-green/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
          
          {/* Central Floating Icon */}
          <div className="mx-auto w-16 h-16 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center mb-8 shadow-xl group-hover:border-electric-green/30 group-hover:bg-electric-green/10 transition-all duration-500">
            <Sparkles className="w-8 h-8 text-electric-green" />
          </div>

          <h2 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight">
            For More Information, <br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">
              Contact Us.
            </span>
          </h2>
          
          <p className="text-gray-400 text-base md:text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
            Whether you need advanced web development, robust cybersecurity, or scalable cloud infrastructure, our team of experts is ready to accelerate your digital growth.
          </p>

          <Link 
            to="/contact" 
            className="inline-flex items-center gap-3 bg-electric-green text-royal-navy px-10 py-4 rounded-xl font-bold text-lg hover:scale-[1.03] active:scale-[0.98] transition-all duration-300 shadow-[0_0_30px_rgba(57,255,20,0.25)] hover:shadow-[0_0_40px_rgba(57,255,20,0.4)]"
          >
            Get in Touch
            <ArrowRight className="w-5 h-5" />
          </Link>
          
        </div>
      </motion.div>
    </section>
  );
};

export default PreFooterCta;